export default __webpack_public_path__ + "static/Earth-Day-Collection-Banner-Desktop-77bdd52545e778cadffe2642c5689de0.webp";